import {
  NO_ELIGIBLE_PLAN_PROMOTION_TEXT,
  SINGLE_ELIGIBLE_PLAN_PROMOTION_TEXT,
} from '../constants/bottomBar.constants';

export function getEligiblePromotionText(
  totalSelectedEligiblePlansQuantity: number,
  totalSelectedPlansQuantity: number,
) {
  if (totalSelectedPlansQuantity === 0) return '';
  if (totalSelectedEligiblePlansQuantity === 0)
    return NO_ELIGIBLE_PLAN_PROMOTION_TEXT;
  if (totalSelectedEligiblePlansQuantity === 1)
    return SINGLE_ELIGIBLE_PLAN_PROMOTION_TEXT;
  return '';
}
